export class Customer {
    id: string;
    name: string;
    commercialName: string;
    phone: string;
    taxNumber: string;
    taxOffice: string;
    email: string;
    publisherId;
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/models/customer.ts